/* eslint-disable no-tabs */
import { COMPANY_PROFILE_DEFAULT } from 'components/icons/constants';
import PropTypes from 'prop-types';

const CeoIcon = ({
    color = COMPANY_PROFILE_DEFAULT.color,
    size = COMPANY_PROFILE_DEFAULT.size
}) => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width={size}
        height={size}
        viewBox="0 0 70.865 70.867"
        enableBackground="new 0 0 70.865 70.867"
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M58.626,12.238c-3.012-3.011-6.519-5.376-10.426-7.026c-4.045-1.711-8.34-2.578-12.769-2.578
		c-4.428,0-8.725,0.867-12.769,2.578c-3.907,1.65-7.414,4.016-10.426,7.026C9.225,15.25,6.86,18.76,5.208,22.665
		c-1.71,4.043-2.576,8.341-2.576,12.768c0,4.428,0.866,8.725,2.576,12.769c1.652,3.906,4.018,7.415,7.03,10.426
		c3.012,3.01,6.519,5.378,10.426,7.027c4.044,1.71,8.341,2.579,12.769,2.579c4.429,0,8.724-0.869,12.769-2.579
		c3.907-1.649,7.414-4.018,10.426-7.027c3.013-3.011,5.379-6.52,7.029-10.426c1.71-4.044,2.578-8.341,2.578-12.769
		c0-4.427-0.868-8.725-2.578-12.768C64.005,18.76,61.639,15.25,58.626,12.238z M35.432,66.291
		c-17.017,0-30.858-13.846-30.858-30.858c0-17.014,13.842-30.857,30.858-30.857c17.016,0,30.859,13.844,30.859,30.857
		C66.292,52.445,52.448,66.291,35.432,66.291z"
            />
            <path
                fill={color}
                d="M50.383,39.183c-1.776-2.693-4.39-4.892-7.772-6.531c-0.351-0.172-0.72-0.313-1.106-0.462
		c-0.185-0.071-0.37-0.139-0.557-0.215l-0.639-0.259l0.53-0.442c2.739-2.289,3.374-4.878,3.422-6.643
		c0.068-2.45-0.968-5.042-2.643-6.604c-1.733-1.617-3.918-2.506-6.16-2.506c-2.19,0-4.347,0.858-6.068,2.423
		c-1.555,1.41-2.459,3.182-2.688,5.263c-0.176,1.61,0.026,3.103,0.604,4.438c0.567,1.316,1.519,2.521,2.823,3.585l0.555,0.45
		l-0.669,0.256l-0.254,0.099c-0.167,0.063-0.308,0.118-0.45,0.168c-3.403,1.236-6.335,3.498-8.479,6.544
		c-2.144,3.047-3.281,6.563-3.289,10.173c-0.002,0.799,0.447,1.36,1.116,1.394c0.018,0.005,0.034,0.005,0.051,0.005
		c0.603,0,1.078-0.559,1.131-1.328c0.015-0.215,0.026-0.438,0.037-0.651c0.029-0.578,0.061-1.171,0.159-1.755
		c1.123-6.762,6.076-11.744,12.477-12.916l1.811,1.397l-3.34,10.318c-0.125,0.384-0.021,0.801,0.264,1.08l3.569,3.489
		c0.205,0.201,0.472,0.302,0.737,0.302c0.267,0,0.533-0.101,0.737-0.302l3.571-3.489c0.285-0.279,0.388-0.696,0.266-1.08
		l-3.341-10.318l1.768-1.366c5.918,1.156,10.836,5.951,12.057,11.831c0.173,0.827,0.251,1.676,0.325,2.497
		c0.037,0.404,0.075,0.816,0.124,1.223c0.065,0.546,0.442,0.948,0.984,1.051c0.044,0.01,0.09,0.013,0.14,0.013
		c0.395,0,0.814-0.259,0.974-0.609c0.112-0.239,0.173-0.543,0.159-0.803C53.144,45.144,52.156,41.875,50.383,39.183z M37.921,45.413
		l-2.366,2.313l-2.363-2.313l2.363-7.306L37.921,45.413z M35.431,30.753h-0.019c-3.589-0.008-6.504-2.921-6.502-6.493
		c0.005-3.604,2.873-6.432,6.531-6.437h0.007c3.652,0,6.515,2.826,6.518,6.43c0.001,1.747-0.676,3.385-1.906,4.605
		C38.83,30.082,37.185,30.753,35.431,30.753z"
            />
        </g>
    </svg>
);

CeoIcon.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.number
};

export default CeoIcon;
